import React, { useEffect, useState } from 'react'
import * as S from './styles'

import { useTranslation } from 'react-i18next'

const CustomSimulator = () => {
  const { t } = useTranslation()

  const [text1, setText1] = useState('')
  const [text2, setText2] = useState('')
  const [text3, setText3] = useState('')
  const [text4, setText4] = useState('')
  const [text5, setText5] = useState('')
  const [text6, setText6] = useState('')
  const [text7, setText7] = useState('')

  useEffect(() => {
    setText1(t('titles.cardiology'))
    setText2(t('titles.firstAid'))
    setText3(t('titles.pulmonology'))
    setText4(t('titles.infectology'))
    setText5(t('titles.neurology'))
    setText6(t('titles.vascular'))
    setText7(t('titles.autoImmune'))
  }, [t])

  return (
    <S.CustomSimulatorContainer>
      <li>{text1}</li>
      <li>{text2}</li>
      <li>{text3}</li>
      <li>{text4}</li>
      <li>{text5}</li>
      <li>{text6}</li>
      <li>{text7}</li>
    </S.CustomSimulatorContainer>
  )
}

export default CustomSimulator
